module.exports = __webpack_public_path__ + "img/double-bed.727684b3.svg";